import React, { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import BridgeMessagingAPI from './bridgeMessagingAPI';

const initialState = {
  isWebView: false,
  bridgeVersion: 0,
  insets: { top: 0, bottom: 0, left: 0, right: 0 }
};
export const BridgeContext = createContext(initialState);

const initialAPI = {
  closeWebview: BridgeMessagingAPI.closeWebview,
  setNoTopInsetRoutes: BridgeMessagingAPI.setNoTopInsetRoutes
};

export const BridgeAPIContext = createContext(initialAPI);

const bridgeReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'handshake': {
      return {
        ...state,
        isWebView: true,
        bridgeVersion: payload.bridgeVersion
      };
    }
    case 'setInsets': {
      return {
        ...state,
        insets: payload.insets
      };
    }
    default:
      return state;
  }
};

const PAYMENT_ORIGINS = [
  'https://sandbox.api.pay.yigim.az',
  'https://api.pay.yigim.az',
  'https://pay.yigim.az',
  'https://sandbox.pay.yigim.az',
  'https://testmpi.3dsecure.az',
  'https://3dsecure.az',
  'https://acs.3dsecure.az',
  'https://mpi.3dsecure.az',
  'https://paymentsmk.millikart.az',
  'https://payments.goldenpay.az',
  'https://portmanat.az'
];

const AUTH_ORIGINS = ['https://hello.bina.az'];

const EMBEDDED_CONTENT_ORIGINS = [
  'https://youtube.com',
  'https://www.youtube.com',
  'https://tap.az',
  'https://ru.tap.az'
];

const AD_CONTENT_ORIGINS = [
  'https://content.adriver.ru',
  'https://mlb1.adriver.ru',
  'https://creativecdn.com'
];

export const BridgeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(bridgeReducer, initialState);

  useEffect(() => {
    BridgeMessagingAPI.handshake();
    BridgeMessagingAPI.setApplicationOriginWhitelist([
      ...PAYMENT_ORIGINS,
      ...AUTH_ORIGINS
    ]);
    BridgeMessagingAPI.setOriginWhitelist([
      ...EMBEDDED_CONTENT_ORIGINS,
      ...AD_CONTENT_ORIGINS
    ]);
  }, []);

  useEffect(() => {
    const callback = nativeEvent => {
      const { data } = nativeEvent;

      if (!data) {
        return;
      }

      try {
        const { eventName, params } = JSON.parse(data);

        if (!eventName) {
          return;
        }

        dispatch({
          type: eventName,
          payload: params
        });
        // eslint-disable-next-line no-empty
      } catch (e) {}
    };

    return BridgeMessagingAPI.subscribe(callback);
  }, []);

  return (
    <BridgeContext.Provider value={state}>
      <BridgeAPIContext.Provider value={initialAPI}>
        {children}
      </BridgeAPIContext.Provider>
    </BridgeContext.Provider>
  );
};

BridgeProvider.propTypes = {
  children: PropTypes.node.isRequired
};
